import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllRolesService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allRolesService = useQuery({
    queryKey: [...CACHE_KEYS.ROLES, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.ROLES,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          include: "partner",
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allRolesService },
    states: { searchQuery, setSearchQuery },
  };
};
